import { app } from '@store/modules/app';
import axios from 'axios';
import { webRequest } from '../request';

let isRefreshing = false;
let subscribers: Array<(args: string) => void> = [];

function addSubscriber(cb: (args: string) => void): void {
	subscribers.push(cb);
}

function onAccessTokenFetched(token: string): void {
	subscribers = subscribers.filter((callback) => callback(token));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function oAuthTokenRefresh(err: any): Promise<unknown> {
	const {
		config,
		response: { status }
	} = err;
	const originalRequest = config;

	if (status === 401) {
		if (!isRefreshing) {
			isRefreshing = true;
			webRequest
				.post('/token/refresh')
				.then(({ data }) => {
					app.SET_OAUTH_TOKEN(data);
					isRefreshing = false;
					onAccessTokenFetched(data);
				})
				.catch(() => {
					window.location.href = `${process.env.VUE_APP_BASE_PATH}/logout`;
				});
		}

		const retryInitialRequest = new Promise((resolve) => {
			addSubscriber((token: string) => {
				originalRequest.headers.authorization = `Bearer ${token}`;
				resolve(axios(originalRequest));
			});
		});

		return retryInitialRequest;
	}

	return Promise.reject(err);
}
